import React from 'react'

export const IdentityContext = React.createContext({});